module.exports = __webpack_public_path__ + "static/media/1POLICY26.5b39c19d.jpg";